import { ReactNode } from 'react';
import { Container, Stack } from '@optimus-web/core';
import { CellDivider, ColoredStack } from './styles';

export interface CellLayoutProps {
    selected?: boolean;
    headerElement?: boolean;
    children: ReactNode;
}

export const CellLayout = ({ children, selected, headerElement }: CellLayoutProps) => (
    <ColoredStack vertical spacing="0" alignment="center" fill selected={selected}>
        <Container padding={['200', '200']} height="100%">
            <Stack itemAlignment="center" fill>
                {children}
            </Stack>
        </Container>
        <CellDivider selected={selected} headerElement={headerElement} />
    </ColoredStack>
);
